import { CompactUserResponse } from '@business/entities/account';
import { ProductStatus, TimeMaterialId } from './TimeMaterialResponse';
import { LabourItemResponse, OrderProductResponse } from '../order';
import { ACHMethodRequest, CompactOrgResponse, OrgAddressResponse, SimpleOrgResponse } from '../organization';
import { ProposalDiscountFormData } from '@modules/proposal/ProposalBuilderPage/Components/ProposalProductsOverlay';

export type TMChangeOrderLineId = string;
export interface TMChangeOrderLineResponse {
  id: TMChangeOrderLineId;
  productId: string;
  serviceId: string;
  classId: string;
  productTitle: string;
  productSku: string;
  quantity: number;
  oldQuantity: number;
  unitPrice: number;
  description: string;
  vendorId: string;
  tierId: number;
  thumbnail: string;
  unitOfMeasure: string;
  taxable: boolean;
  cost: number;
  status: ProductStatus;
  received: number;
  labourItems: LabourItemResponse[];
  lineCopyId: string;
  issuedQuantity?: number;
  warehouseStatus?: string;
  packageItems: TMChangeOrderLineResponse[];
  hasParent?: boolean;
  title?: string;
  product: OrderProductResponse;
}

export enum TMChangeOrderStatus {
  open = 'open',
  sent = 'sent',
  approved = 'approved',
  paid = 'paid',
}

export type TMChangeOrderId = string;
export interface TMChangeOrderResponse {
  id: TMChangeOrderId;
  tmId: TimeMaterialId;
  //   date: number;
  items: TMChangeOrderLineResponse[];
  createdBy: CompactUserResponse;
  createdAt: number;
  amount: number;

  billingAddress?: OrgAddressResponse;
  organization?: CompactOrgResponse | SimpleOrgResponse;
  name?: string;
  orderNumber?: string;
  description?: string;
  signedAt?: number;
  sign?: string;
  status: TMChangeOrderStatus;
  salesTax: number;
  totalDiscount: number;
  discount: ProposalDiscountFormData;
  taxAfterDiscount: boolean;
  salesReps: string;
}

export interface TMChangeOrderDepositAchRequest extends Omit<ACHMethodRequest, 'phone'> {
  save: boolean;
  amount: number;
  address?: Partial<OrgAddressResponse>;
}

export type TMChangeOrdeRDepositCardRequest = {
  name: string;
  cardNumber: string;
  expiryMonth: number | string;
  expiryYear: number | string;
  cvv: string;
  save: boolean;
  amount: number;
  address?: Partial<OrgAddressResponse>;
};
